/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Agents_Role_DeliversInputs */



/**
* | output |
* | --- |
* | "Files results here" |
*
* @param {Datasets_Agents_Role_DeliversInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_agents_role_delivers = /** @type {((inputs?: Datasets_Agents_Role_DeliversInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Agents_Role_DeliversInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Legt Ergebnisse hier ab")
	return /** @type {LocalizedString} */ ("Files results here")
});